<script setup>
import { show as projectShow } from '@/actions/App/Http/Controllers/ProjectController'

defineProps({
    project: {
        type: Object,
        required: true,
    },

    productTextColor: {
        type: String,
        default: 'text-gray-900',
    },

    productDateColor: {
        type: String,
        default: 'text-gray-500',
    },
})
</script>

<template>
    <article
        class="group relative"
        :aria-labelledby="`event-title-${project.name}`"
    >
        <div class="relative">
            <img
                :src="project.thumbnail"
                :srcset="project.thumbnail_2x ? `${project.thumbnail} 1x, ${project.thumbnail_2x} 2x` : null"
                :alt="project.name"
                loading="lazy"
                class="aspect-4/3 w-full rounded-3xl bg-gray-100 object-cover"
            />

            <div
                class="absolute inset-0 flex -translate-y-2 items-end p-4 opacity-0 transition-all duration-100 ease-linear group-hover:translate-y-0 group-hover:opacity-100"
                aria-hidden="true"
            >
                <Link
                    :href="projectShow.url(project.slug)"
                    :aria-label="'Přejít na stránku produktu ' + project.name"
                    class="w-full overflow-hidden rounded-full bg-black/50 px-4 py-2 text-center text-sm font-medium text-white backdrop-blur-sm backdrop-filter"
                >
                    Zobrazit stavbu
                </Link>
            </div>
        </div>

        <div class="flex flex-row justify-between p-4">
            <header :class="productTextColor">
                <h3>
                    <Link
                        :href="projectShow.url(project.slug)"
                        class="text-sm font-semibold hover:underline"
                        :aria-label="'Přejít na stránku produktu ' + project.name"
                    >
                        {{ project.name }}
                    </Link>
                </h3>
                <p>
                    <span class="font-normal"> {{ project.published_at_formatted }}</span>
                </p>
            </header>

            <footer class="text-sm">
                <p :class="productDateColor">
                    {{ project.date }}
                </p>
            </footer>
        </div>
    </article>
</template>
